import { cleanCommonParams } from './common';

const mapUserParams = (isCreate, params) => {
    return new Promise((resolve) => {
        resolve({
            user: {
                ...cleanCommonParams(params),
            },
        });
    });
};

export { mapUserParams };
